// extracted by mini-css-extract-plugin
export default {"divider":"_3vzoQ___Divider-module__divider"};